<script setup>
// ルーターを使用するため、コンポーネントのインポートは不要
</script>

<template>
  <router-view />
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;

  *:focus {
    box-shadow:none !important;
  }
}
</style>
